/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_sales = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	this.onready = function() {

		/*
		Listener
		*/
		$(document).on('click','.js-sale-submit',function() {
			specific_sales.save();
		});

		$(document).on('click','.js-sale-active-submit',function() {
			specific_sales.saveActive();
		});

		$(document).on('click','.js-sale-delete-submit',function() {
			specific_sales.delete();
		});

		/*
		Submit: Send
		*/
		$(document).on('click','.js-sale-send',function() {

			var _sale_id 		= $('.js-sale-id').val();

			popup.open(1,1,'sale-pdf/' + _sale_id);

		});
	
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************

	/*
	Save *************************
	Save *************************
	Save *************************
	Save *************************
	*/
	this.save = function(
	) {

		var _sale_id 		= $('.js-sale-id').val();
		var _sale_client 	= $('.js-client-id').val();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/sale-action',
			type: "POST",
			data: {
				sale_id 		: _sale_id,
				sale_client		: _sale_client
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Get: List
			*/
			specific_overview.getList(
				'list',
				'sales'
			);

			/*
			Close popup
			*/
			popup.close();

		})
		.always(function() {
		});

	};

	/*
	Save active *************************
	Save active *************************
	Save active *************************
	Save active *************************
	*/
	this.saveActive = function(
	) {

		var _sale_id 		= $('.js-sale-id').val();
		var _sale_active 	= $('.js-sale').val();
		var _sale_overview 	= $('.js-sale-overview').val();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/sale-active-action',
			type: "POST",
			data: {
				sale_id 			: _sale_id,
				sale_status 		: _sale_active
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			if(_sale_overview == 'active') {
				
				/*
				Get: List
				*/
				specific_overview.getList(
					'list',
					'sales'
				);

			} 

			if(_sale_overview == 'archived') {
				setTimeout(function() {
					$('.js-nav-item-sales').trigger('click');
				},500);
			} 

			/*
			Close popup
			*/
			popup.close();

		})
		.always(function() {
		});

	};

	/*
	Delete *************************
	Delete *************************
	Delete *************************
	Delete *************************
	*/
	this.delete = function(
	) {

		var _sale_id 		= $('.js-sale-id').val();
		var _sale_overview 	= $('.js-sale-overview').val();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/sale-delete',
			type: "POST",
			data: {
				sale_id 			: _sale_id
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			if(_sale_overview == 'active') {
				
				/*
				Get: List
				*/
				specific_overview.getList(
					'list',
					'sales'
				);

			} 

			if(_sale_overview == 'archived') {
				setTimeout(function() {
					$('.js-nav-item-sales').trigger('click');
				},500);
			} 

			/*
			Close popup
			*/
			popup.close();

		})
		.always(function() {
		});

	};
		
}).apply(specific_sales); 